import { useEffect, useState } from 'react';

import { getAudioClientService } from 'services';
import { useGlobalState } from 'utils';

type UseInputResT = {
  label: string;
  refresh: () => void;
  stream: MediaStream | null;
};

export function useInput(): UseInputResT {
  const [, setBlockedAudioDeviceAccess] = useGlobalState(
    'ui.blockedAudioDeviceAccess',
  );

  const [res, setRes] = useState<UseInputResT>({
    label: '',
    refresh: () => {
      void (async () => {
        try {
          const audio = await getAudioClientService();
          const stream = await audio.getInputStream();
          const label: string = stream.getTracks()[0]?.label ?? '';

          setRes((prev) => ({ ...prev, label, stream }));
        } catch (error) {
          if (error instanceof Error && error.name === 'NotAllowedError') {
            setBlockedAudioDeviceAccess(true);
          } else {
            throw error;
          }
        }
      })();
    },
    stream: null,
  });

  // NOTE: The way we update `res`, its .refresh() method never changes after it
  // is first set.
  const { refresh } = res;

  useEffect(() => {
    refresh();

    const cleanupPromise = (async () => {
      const audio = await getAudioClientService();
      return audio.emitter.addListener((event) => {
        if (event === 'AUDIO_INPUT_CHANGE') refresh();
      });
    })();

    return () => {
      void (async () => {
        const cleanup = await cleanupPromise;
        cleanup();
      })();
    };
  }, [refresh]);

  return res;
}
